var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useState } from 'react';
import * as React from 'react';
import { saveAllocationRecord } from '../../services/server-api';
import { PrimaryButton, DefaultButton, Stack, TextField } from '@fluentui/react';
import { currencyRadioOptions, defaultCurrency } from '../currencies';
import { horizontalChoiceGroup, stackTokens, StyledChoiceGroup } from '../styles';
import { expandISODate, todayAsISODate, collapseISODate } from '../../common/date.utils';
import { CurrencyInput } from '../currency-input';
export var AddCashAssetAllocation = function (_a) {
    var onClose = _a.onClose;
    var _b = useCaaForm(), allocation = _b.allocation, updateRecord = _b.updateRecord, updateCurrency = _b.updateCurrency, submitForm = _b.submitForm;
    if (!updateRecord)
        return null; //TODO show a spinner
    return (React.createElement("form", null,
        React.createElement(Stack, { tokens: stackTokens },
            React.createElement(TextField, { label: "Date", type: "date", onChange: updateRecord, value: expandISODate(allocation.recordDate), name: "recordDate" }),
            React.createElement(TextField, { label: "Allocation Code", name: "allocationCode", value: allocation.allocationCode, onChange: updateRecord }),
            React.createElement(StyledChoiceGroup, { selectedKey: allocation.currency, label: "Currency", styles: horizontalChoiceGroup, onChange: updateCurrency, options: currencyRadioOptions }),
            React.createElement(CurrencyInput, { amount: allocation.amount, currency: allocation.currency, name: "amount", onChange: updateRecord }),
            React.createElement(TextField, { label: "Notes", name: "note", value: allocation.note, multiline: true, onChange: updateRecord }),
            React.createElement(Stack, { horizontal: true, tokens: stackTokens },
                React.createElement(PrimaryButton, { onClick: submitForm }, "Save"),
                React.createElement(DefaultButton, { onClick: onClose }, "Cancel")))));
};
function useCaaForm() {
    var _this = this;
    var _a = useState(initializeRecord()), allocation = _a[0], setAllocation = _a[1];
    var updateCurrency = useCallback(function (_, _a) {
        var key = _a.key;
        setAllocation(__assign(__assign({}, allocation), { currency: key }));
    }, [allocation]);
    var updateRecord = useCallback(function (_a) {
        var _b;
        var target = _a.target;
        setAllocation(__assign(__assign({}, allocation), (_b = {}, _b[target.name] = target.type == 'date' ? collapseISODate(target.value) : target.value, _b)));
    }, [allocation]);
    var submitForm = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, saveAllocationRecord(allocation)];
                case 1:
                    _a.sent();
                    setAllocation(initializeRecord());
                    return [2 /*return*/];
            }
        });
    }); }, [allocation]);
    return { allocation: allocation, updateRecord: updateRecord, updateCurrency: updateCurrency, submitForm: submitForm };
}
function initializeRecord() {
    return {
        // id: -1,
        recordDate: todayAsISODate(),
        amount: null,
        allocationCode: '',
        currency: defaultCurrency,
        note: ''
    };
}
